<template>
  <div class="">
    <iframe id="iframe" :src="`/forms.html?${urlParams}`" ref="iframe"></iframe>
  </div>
</template>

<script>
export default {
  data: () => ({
    urlParams: "",
  }),
  created() {
    const params = new URLSearchParams(window.location.search);
    params.set("stormport_api_base_url", process.env.API_URL);
    params.set("stormport_api_token", this.$store.state.Auth.token);
    // params.set("api_base_url", "https://v1022.stormport-beta.nz");
    // // params.set("api_base_url", "http://v0523.stormport-beta.nz");
    // params.set("api_key", "x7Y1Bbrr7JMePSUxHOkZ1CFzC6RD2tlu");
    // params.set("auth0_url", "https://core-beta.us.auth0.com/authorize");
    // params.set("auth0_client_id", "cGKoFaQ1lNumK00bfbfBkmdHWw2M1zqV");
    // params.set("auth0_audience", "https://core-api/");
    params.set("api_base_url", process.env.FORMIO_API_URL);
    params.set("api_key", process.env.FORMIO_API_KEY);
    params.set("auth0_url", `https://${process.env.AUTH0_DOMAIN}/authorize`);
    params.set("auth0_client_id", process.env.AUTH0_CLIENT_ID);
    params.set("auth0_audience", process.env.AUTH0_AUDIENCE);
    // if (this.$route.query.order_id) {
    //   params.append("order_id", this.$route.query.order_id);
    // }
    // if (this.$route.query.operation_id) {
    //   params.append("order_operation_id", this.$route.query.operation_id);
    // }
    // if (this.$route.query.form_type_code) {
    //   params.append("form_type_code", this.$route.query.form_type_code);
    // }
    // if (this.$route.query.form_id) {
    //   params.append("form_id", this.$route.query.form_id);
    // }
    this.urlParams = params.toString();
  },
  mounted() {
    window.onmessage = (event) => {
      if (event.data && event.data.id == "formio-create") {
        window.history.replaceState(
          {},
          "",
          `${window.location.origin}${window.location.pathname}?form_id=${event.data.data.id}`
        );
      }
      if (event.data && event.data.id == "submitDone") {
        console.log("iframe console", event.data);
        if (this.$route.query.order_id) {
          this.$router.push({
            name: "order-list",
            query: {
              orderId: this.$route.query.order_id,
            },
          });
        }
      }
    };
  },
};
</script>

<style scoped>
iframe {
  height: calc(100vh - 50px);
  width: 100vw;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Forms/crud/index.vue